
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import AppShell from '@/components/layout/AppShell';
import { useAppShell } from '@/components/layout/AppShellContext';

type ProtectedRouteProps = {
  children: React.ReactNode;
  /** Skip the AppShell wrapper (for full-bleed pages like /test). */
  bare?: boolean;
};

const ProtectedRoute = ({ children, bare }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { inShell } = useAppShell();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/auth', { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!loading && user) {
    return bare || inShell ? <>{children}</> : <AppShell>{children}</AppShell>;
  }

  return null;
};

export default ProtectedRoute;

